var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinimizeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.04839 6.82369L9.19997 6.82369C9.53115 6.82369 9.79994 7.0961 9.79994 7.43161C9.79994 7.76712 9.53115 8.03943 9.19997 8.03943L5.59995 8.03943C5.26877 8.03943 4.99998 7.76712 4.99998 7.43161L4.99998 3.7845C4.99998 3.44899 5.26877 3.17658 5.59995 3.17658C5.93113 3.17658 6.19992 3.44899 6.19992 3.7845L6.19992 5.96422L10.5757 1.53116C10.8097 1.29406 11.1902 1.29406 11.4241 1.53116C11.6588 1.76816 11.6588 2.15354 11.4241 2.39063L7.04839 6.82369Z",
    fill: "#4F6E90"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.40008 0.340332H2.39998C1.07458 0.340332 0 1.42897 0 2.7717V10.0659C0 11.4087 1.07458 12.4974 2.39998 12.4974H9.60002C10.9254 12.4974 12 11.4087 12 10.0659V7.02684C12 6.69123 11.7312 6.41892 11.4 6.41892C11.0689 6.41892 10.8001 6.69123 10.8001 7.02684V10.0659C10.8001 10.737 10.2625 11.2817 9.60002 11.2817H2.39998C1.73693 11.2817 1.19994 10.737 1.19994 10.0659V2.7717C1.19994 2.10009 1.73693 1.55607 2.39998 1.55607H5.40008C5.73126 1.55607 6.00005 1.28366 6.00005 0.948149C6.00005 0.612641 5.73126 0.340332 5.40008 0.340332Z",
    fill: "#4F6E90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinimizeIcon);
export default __webpack_public_path__ + "static/media/minimize-icon.df2330f72202d065f9f8d0e422d7cb11.svg";
export { ForwardRef as ReactComponent };